import { useEffect } from "react";

export default function TermsOfServices() {
  // scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="space-y-4 p-2 md:p-8">
      <div className="mb-24 flex w-full flex-col gap-5 px-5 py-5 text-white md:px-0 md:py-0">
        <h3 className="text-center text-[24px] font-bold">
          GENERAL TERMS OF SERVICES
        </h3>
        <p className="text-center text-[16px] text-muted md:pr-10">
          AURORA ACES S.R.L
        </p>
        <p className="text-center text-[12px] text-muted md:pr-10">
          Effective on 1st September, 2024
        </p>

        <p className="text-justify text-[16px] md:pr-10">
          These General Terms of Services - hereinafter referred to as "ToS" -
          set out the content and terms of the contractual relationship between
          AURORA ACES S.R.L. 3-102-913639, San José, Escazú, San Rafael, Office
          10 PLAZA FLORENCIA, 10203 Costa Rica., the operator of the
          www.sharkroll.io platform - hereinafter referred to as "Service
          Provider or SHARKROLL" - and the customer - hereinafter referred to as
          "Customer".
          <br /> <br />
          By ticking the checkbox for this ToS at the beginning of the
          platform's use and clicking on the "I have read and accepted the ToS"
          option, the Customer (i) confirms that he/she has read and accepts to
          be bound by this ToS and is therefore obliged to comply with its
          provisions; (ii) declares and warrants that he/she is entitled and
          legally able to enter into these terms and conditions on behalf of
          himself/herself.
          <br /> <br />
          If the Customer does not accept all the terms and conditions of the
          ToS, he/she is not entitled to use the services and the platform
          subject to these general terms and conditions.
          <br /> <br />
          Please read the following TOS carefully before using the Sharkroll
          website or any available services.
          <br />
          <br />
          Please also note that the services available on the SHARKROLL website
          are provided through the use of third party(ies). The services of such
          third party(ies) are not under our control, and we are not responsible
          for the content, products or services of any third party(ies). The
          Service Provider is, therefore, not liable for any damage or loss
          relating to the services of a third party(ies).
          <br />
          <br />
          These terms represent the entire agreement and understanding between
          you and SHARKROLL. SHARKROLL may modify them from time to time or
          assign them to a group company. It is your responsibility to check for
          any such amendments or changes.
          <br /> <br />
          RISK WARNING
          <br /> <br />
          BEFORE USING SHARKROLL.IO OR ANY SHARKROLL SERVICE, YOU SHOULD BE
          AWARE OF THE DANGERS AND RISKS OF TRADING IN VIRTUAL CURRENCIES AND
          THE COMPLEX SERVICES ASSOCIATED WITH VIRTUAL CURRENCIES. THE VIRTUAL
          CURRENCY MARKETS ARE HIGHLY VOLATILE AND INVOLVE TECHNOLOGICAL,
          SERVICE, COUNTERPARTY AND OTHER RISKS THAT MAY SIGNIFICANTLY AFFECT
          THE PRICE OF VIRTUAL CURRENCIES IN THE SHORT TERM, INCLUDING THE RISK
          OF TOTAL OR PARTIAL LOSS OF ASSETS. THERE MAY ALSO BE OTHER RISKS THAT
          ARE NOT LISTED OR DESCRIBED IN THESE TERMS AND CONDITIONS.
          <br /> <br />
          YOU MUST ALSO BE AWARE OF YOUR FINANCIAL SITUATION AND YOUR RISK
          TOLERANCE SO THAT YOU CAN MAKE INFORMED DECISIONS WHEN TRADING OR
          GAMBLING IN VIRTUAL CURRENCIES. YOU AGREE AND ACCEPT THAT YOU ARE THE
          ONLY RESPONSIBLE PERSON AND ARE SOLELY RESPONSIBLE FOR YOUR ACTIONS
          AND ALL DECISIONS REGARDING YOUR TRANSACTIONS IN VIRTUAL CURRENCIES.
          <br /> <br />
          YOU FURTHER AGREE THAT THE SHARKROLL PLATFORM, ITS OPERATOR, OWNERS OR
          OPERATORS SHALL NOT BE LIABLE FOR ANY LOSS OF ASSETS OR ASSET VALUE
          CAUSED BY THE FAULT OF ANY THIRD PARTY INVOLVED IN THE OPERATION OF
          THE SERVICE.
          <br /> <br />
          YOU ACKNOWLEDGE THAT YOU UNDERSTAND THE RISKS ASSOCIATED WITH THE USE
          OF THE SERVICE, THAT YOU CONSIDER THESE RISKS TO BE PROPORTIONATE TO
          THE BENEFITS OF THE SERVICES PROVIDED BY THE PLATFORM AND THAT YOUR
          DECISIONS IN USING THE SERVICES ARE YOUR SOLE INFLUENCE ON THE VALUE
          OF YOUR ASSETS.
        </p>

        <h3 className="text-[20px] font-bold">1. ACCOUNT OPENING</h3>
        <p className="text-justify text-[16px] md:pr-10">
          1.1 In order to play and wager real money with Sharkroll, you must be
          over 18 years of age, resident in a jurisdiction where online wagering
          is not prohibited by law and complete the application for account
          opening and membership in the manner set out on the www.sharkroll.io
          site (the “Website”).
          <br /> <br />
          1.2 You warrant that all information you provide during the
          application process is accurate, true, and complete at the time of
          submission. You further agree to promptly notify us of any changes to
          the information provided, ensuring that all details remain current and
          accurate. Such notification must be made as soon as reasonably
          possible after the change occurs. Failure to do so may result in the
          suspension or termination of your account or other applicable actions
          as deemed necessary.
          <br /> <br />
          1.3 We will take appropriate measures to ensure that your personal
          information, as disclosed to SHARKROLL, remains confidential and will
          be processed in accordance with our Privacy Policy, as amended from
          time to time. We will not disclose your personal data or wagering
          information unless compelled to do so by court order or other
          authority in accordance with applicable laws and regulations or as
          otherwise provided for in these Terms of Services. We reserve the
          right to disclose and transfer your personal data to our service
          providers, partners, group companies, affiliates and financial
          institutions under strict legal conditions on use and security to the
          extent necessary for the completion of the online casino and
          associated payment processing services provided by SHARKROLL through
          the Website (the “Services”) or provide restricted personal data to
          third parties, sufficient only for the marketing to you of similar
          and/or related services.
          <br /> <br />
          1.4 You are allowed to open only one wagering account with SHARKROLL.
          Should we discover that you have more than one account, we reserve the
          right, at our sole discretion, to terminate this Agreement.
          <br /> <br />
          1.5 By registering an account on our site, you agree that you have
          thoroughly read and understood the Responsible Gambling Policy. The
          company will not be held liable for any losses incurred due to a
          failure to read the below terms.
        </p>

        <h3 className="text-[20px] font-bold">2. PLACING A WAGER</h3>
        <p className="text-justify text-[16px] md:pr-10">
          2.1 We accept wagers for those games that are advertised on the
          Website from time to time. All such wagers are subject to the relevant
          rules applicable to each game and to these Terms of Services. If an
          error occurs, all wagers placed on that game shall be void. In the
          event of any malfunction to the SHARKROLL gaming system, the Company
          reserves the right to void all wagers placed.
          <br /> <br />
          2.2 You are responsible for all activities and transactions that take
          place using your username and/or password. As such, you should ensure
          that underage or other persons are prevented from having access to
          your username, password and debit/credit card details.
          <br /> <br />
          2.3 Please note that all wagers are logged and recorded in the
          transaction log database. SHARKROLL’s transaction logs are conclusive
          evidence of all transactions and the times at which they are placed.
        </p>

        <h3 className="text-[20px] font-bold">3. GENERAL PROVISIONS</h3>
        <p className="text-justify text-[16px] md:pr-10">
          3.1 As a condition of use of the Services, you warrant that you shall
          not use or access the Website and Services for any purpose that is
          unlawful in the jurisdiction in which you are resident and/or in
          breach of these Terms of Services. Residents of the following
          countries and their territories shall not be allowed to partake in
          real money gambling activities:
          <br /> <br />
          Afghanistan, Algiria, American Samoa, Anguilla, Antigua and Barbuda,
          Argentina, Bahrain, British Virgin Islands, Brunei, Cambodia, Chile,
          Colombia, Costa Rica, Cuba, Cyprus, Eritrea, Ethiopia, Fiji, Guam,
          Indonesia, Iran, Japan Jordan, Kosovo, Lebanon, Lybia, Mauritania,
          Myanmar, North Korea (DPRK), Pakistan, Palau, Panama, Poland, Qatar,
          Russia, Samoa, Singapore, Somalia, Sudan, Syria, Trinidad and Tobago,
          UAE, US Virgin Islands, USA
          <br /> <br />
          You warrant that as a condition of use of the Services:
          <br /> <br />
          3.1.1 You are over 18 or over the applicable age of majority for
          gambling in your country of residence.
          <br />
          3.1.2 You are not depositing money originating from criminal or other
          illegal activities.
          <br />
          3.1.3 You remain solely responsible for all activities that occur
          under the access to and use of the Services under your username and
          password, regardless of whether such access and/or use was authorised
          by or known to you or not.
          <br />
          3.1.4 You will not use the Services, Software (as defined in Section
          4.1 below) and Website in any way which interferes or may interfere
          with the availability of the Services and the Website to other users,
          nor do anything that degrades or may degrade the operational
          performance of the Services and Website.
          <br />
          3.1.5 You acknowledge that our random number generator will determine
          the outcome of the games played on the Website, and you accept the
          outcomes of all such games. You further agree that, in the unlikely
          event of a disagreement between the result that appears on the
          Software and the game server, the result that appears on the game
          server will prevail. You acknowledge and agree that our records will
          be the final authority in determining the terms and circumstances of
          your participation in the gaming activity.
          <br />
          3.1.6 You agree that we or a payment processing company on our behalf
          will handle all financial account transactions ("Payment Processor").
          You hereby agree that the Payment Processor reserves the right to
          withhold any payments should the Payment Processor have reason to
          believe or suspect that you may be engaging in, or have engaged in,
          money laundering, fraud, collusion, unlawful, or improper activity.
          <br />
          3.1.7 You will not commit any acts or display any conduct that damages
          our reputation or the reputation of our Software provider or any other
          related service providers.
          <br />
          3.1.8 You confirm that all details you provide or have provided in the
          process of registering to use the Services are accurate and that you
          will continue to update such details should there be any changes.
          <br />
          3.1.9 To maintain their player class and associated benefits, players
          are required to wager a percentage of their balance accumulated over a
          specified period. SHARKROLL reserves the right to close an account if
          these conditions are not fulfilled.
          <br /> <br />
          3.2 In addition to other rights available to SHARKROLL under this
          Agreement, SHARKROLL reserves the right, in its sole discretion, to
          void any winnings and forfeit any balance in your betting account,
          thereby terminating the Agreement and/or suspending the provision of
          the Services/deactivating your account if SHARKROLL has the reasonable
          grounds to believe any of the following:
          <br /> <br />
          3.2.1 The name you provide on account registration does not match the
          name on the credit or debit card(s) or other payment accounts used to
          make purchases and deposits.
          <br />
          3.2.2 We suspect fraudulent activity or cheating on your part.
          <br />
          3.2.3 Any of your payments are charged back.
          <br />
          3.2.4 You failed or neglected to provide the requested identification
          information for a period of 6 months after we notified you and issued
          warnings.
          <br />
          3.2.5 You are not of legal age.
          <br />
          3.2.6 You access and participate in the Services from a jurisdiction
          where participation in the Services is prohibited by law.
          <br />
          3.2.7 You are depositing money originating from criminal or other
          illegal or unauthorised activities.
          <br />
          3.2.8 You are found to be cheating or attempting to cheat, or if it is
          determined by SHARKROLL that you have employed or made use of an
          artificial intelligence or other system designed to defeat the system,
          or you are found to have colluded or attempted to collude with other
          players/affiliates in order to defraud SHARKROLL.
          <br />
          3.2.9 You have allowed or permitted someone else to use your account.
          <br /> <br />
          3.3 We reserve, at our sole discretion, the right to:
          <br /> <br />
          3.3.1 Refuse to register any applicant for registration on the
          Website. 3.3.2 Refuse to accept any wager.
          <br />
          3.3.3 Change, suspend, remove, modify or add any game or tournament.
          <br />
          3.3.4 Make inquiries on you, including credit checks, with third-party
          credit and financial institutions in accordance with the information
          you have provided us with.
          <br />
          3.3.5 If no additional deposit is made within a specified period, the
          playable balance may be removed or deleted from the player's account.
          <br /> <br />
          3.4 SHARKROLL takes complaints very seriously. They will be
          investigated internally, and any decision will be reported back to you
          within a reasonable time. If there is still any disagreement between
          us, then we may, at our absolution discretion, refer the complaint to
          a third-party arbitrator whose final decision will be binding on both
          parties.
        </p>

        <h3 className="text-[20px] font-bold">
          4. INTELLECTUAL PROPERTY AND SOFTWARE
        </h3>
        <p className="text-justify text-[16px] md:pr-10">
          4.1 The information, material, content and data provided or made
          available to you on the Website including, without limitation
          (hereinafter collectively referred to as the “Intellectual Property”):
          marketing programs and materials; text; graphics; video and audio
          content; trademarks and logos, Software and data files that are
          required to be downloaded and used by you to enjoy the Services
          (“Software”) belong to SHARKROLL and/or its licensors and are for your
          personal and non-commercial use only.
          <br /> <br />
          4.2 Save as expressly provided by these Terms of Services, you may not
          in any way or by any means copy, modify, distribute, publish, sell,
          license or otherwise make the Intellectual Property to any other
          person or on another Website, online service or bulletin board, or on
          any other media, without our express prior written consent.
          <br /> <br />
          4.3 All rights, title and interest in and to the Intellectual Property
          are owned by, licensed to and/or controlled by SHARKROLL (or its
          licensors). You acknowledge that you do not acquire any rights or
          interests, or any licenses to the Software, services and the
          Intellectual Property through your use of the same unless otherwise
          provided for herein.
          <br /> <br />
          4.4 SHARKROLL hereby grants to you a personal, non-exclusive,
          non-transferable and revocable license to install and/or use the
          Software.
          <br /> <br />
          4.5 Upon termination of this Agreement for whatever reason, the
          License issued under this Agreement is automatically revoked, and you
          shall stop using the Software and uninstall the Software from your
          device.
          <br /> <br />
          4.6 The Software is provided "as is" without any warranties,
          conditions, undertakings or representations, express or implied,
          statutory or otherwise. We hereby exclude all implied terms,
          conditions and warranties (including any merchantability, satisfactory
          quality and fitness for any particular purpose).
          <br /> <br />
          4.7 We do not warrant that the Software will be non-infringing, that
          the operation of the Software will be error-free or uninterrupted, or
          that any defects in the Software will be corrected, or that the
          Software or the servers are virus-free. In the event of communications
          or system errors occurring in connection with the settlement of
          accounts or other features or components of the Software, neither we
          nor our Software provider will be liable to you or to any third party
          for any costs, expenses, losses or claims arising resulting from such
          errors. We further reserve the right in the event of such errors to
          remove all relevant games from the Software and the Website, void all
          wagers affected by such error, including the cancellation of all
          player winnings attributable to such error and take any other action
          to correct such errors. In any event, our liability and that of the
          Software provider for any purported lost winnings due to such errors
          is limited to the lesser sum of the following: the amount of the
          purported win or 10,000(€).
          <br /> <br />
        </p>

        <h3 className="text-[20px] font-bold">
          5. TRANSACTIONS AND WITHDRAWAL POLICY
        </h3>
        <p className="text-justify text-[16px] md:pr-10">
          5.1 You are fully responsible for paying all monies owed to SHARKROLL.
          In respect of any payment made by you, you agree that you will not
          make any chargebacks and/or deny or reverse any such payment and that
          you will reimburse Sharkroll for any chargebacks, denials or reversal
          of payments you make and all other losses suffered, and expenses
          incurred by SHARKROLL as a consequence. SHARKROLL may, at its sole and
          absolute discretion, cease to provide services or payment to certain
          users or to users paying with certain credit or debit cards.
          <br /> <br />
          5.2 All your winnings will be credited to your account. SHARKROLL
          shall not in any way be responsible or liable to you for any
          funds/winnings credited to an account in error, and SHARKROLL reserves
          the right to void any transactions involving such funds, either at the
          time or retrospectively. Should funds be credited to your account in
          error, it is your responsibility to inform SHARKROLL immediately.
          <br /> <br />
          5.3 Payment of any taxes, fees, charges or levies that may apply to
          your winnings under any applicable laws shall be solely your
          responsibility.
          <br /> <br />
          5.4 Before withdrawing, you will be required to provide proof of your
          identity, payment methods, date of birth, and residential address by
          supplying validated (certified or notarised and as specified by our
          customer services team) copies of the original documents (“I.D.
          Documentation”), credit cards, or other relevant materials, such as a
          picture of you holding up a requested document.
          <br /> <br />
          5.5 A minimum deposit is required, the amount of which will vary based
          on the chosen currency or its equivalent.
          <br /> <br />
          5.6 VIP players may withdraw a maximum amount per week, with any
          withdrawal requests exceeding this limit processed in weekly
          increments until the full amount is withdrawn. Notwithstanding this,
          we may, at our absolute discretion, agree to greater levels of
          withdrawal limits with VIP players on a case-by-case basis to be
          arranged with our customer services team. Processing times may vary
          depending on the payment method and the expediency with which you
          provide the necessary I.D. documentation, but every effort will be
          made to ensure that the requested amounts are paid out as soon as
          possible.
          <br /> <br />
          5.7 Sharkroll will use its reasonable endeavours to release a player’s
          funds using their preferred method. However, where necessary, to
          comply with local laws and regulations and to ensure both parties’
          security, Sharkroll reserves the right to release a player’s winnings
          using the most appropriate payment method determined at Sharkroll’s
          absolute discretion.
          <br /> <br />
          5.8 A minimum withdrawal amount is required for bank transfers, and a
          fee will be applied to all such transactions. The exact amounts for
          both the minimum withdrawal and the fee will vary based on the
          currency used.
          <br /> <br />
          5.9 If the balance due is less than the Minimum Threshold, it shall be
          accumulated, carried over and payable when it collectively exceeds the
          Minimum Threshold.
          <br /> <br />
          5.10 All deposits to the casino must be turned over in full before
          requesting a withdrawal.
          <br /> <br />
          5.11 A minimum deposit is required before a withdrawal request can be
          made, with the amount varying based on the selected currency.
        </p>

        <h3 className="text-[20px] font-bold">6. PROMOTIONS AND BONUSES</h3>
        <p className="text-justify text-[16px] md:pr-10">
          6.1 All promotions and bonuses offered by SHARKROLL are subject to the
          terms and conditions outlined in this policy, as well as any
          additional terms provided in the specific promotion. Bonuses and
          promotional offers are limited to one per user, household, or IP
          address, unless otherwise specified.
          <br /> <br />
          6.2 Eligibility for promotions is contingent on meeting specific
          wagering or participation requirements, which will be clearly stated
          for each promotion. All bonus funds, including USD and SHRL tokens,
          must be wagered 30 times in our casino before a withdrawal can be
          made. Wagering cannot be completed on table games such as Blackjack
          and Roulette, or on live dealer tables.
          <br /> <br />
          6.3 SHARKROLL reserves the right to modify, suspend, or cancel any
          promotion or bonus at its discretion. Any misuse or abuse of
          promotional offers may result in the forfeiture of the bonus and
          possible account closure. Additionally, SHARKROLL reserves the right
          to withhold or remove bonuses if irregular gaming patterns or
          fraudulent activity are detected.
          <br /> <br />
          6.4 Free SHRL tokens earned through promotions will be distributed
          within 48 hours of the Token Generation Event (TGE), currently planned
          for March 31, 2025. Participants are encouraged to review each
          promotion’s specific terms carefully, as engagement in any promotional
          activity implies acceptance of these conditions.
        </p>

        <h3 className="text-[20px] font-bold">
          7. DISCLAIMERS AND SPECIFIC WARNINGS
        </h3>
        <p className="text-justify text-[16px] md:pr-10">
          7.1 Some legal jurisdictions have not addressed the legality of online
          and/or offshore online gambling, while others have specifically made
          online (within the jurisdiction and/or offshore) gambling illegal. We
          do not intend for anyone to use and access the Website and/or the
          Services where such use or access is illegal. The availability of the
          Services should not be construed as an offer, solicitation or
          invitation by us to use or access the foregoing in any country in
          which such use or access is illegal. Compliance with any laws
          applicable to you is entirely your own responsibility, and SHARKROLL
          makes no representation whatsoever that the Services, Software, or
          Website therein comply with any laws applicable to you.
        </p>

        <h3 className="text-[20px] font-bold">8. DORMANT ACCOUNT</h3>
        <p className="text-justify text-[16px] md:pr-10">
          8.1 Sharkroll will email you after five months of inactivity, giving
          you one month's notice that this policy will be in effect on your
          account. To stop this process, please either withdraw your funds or
          place a wager in the casino.
        </p>

        <h3 className="text-[20px] font-bold">9. ACCOUNT CLOSURE</h3>
        <p className="text-justify text-[16px] md:pr-10">
          9.1 If you wish to close your account, please email us at
          <a href="mailto:support@sharkroll.io" className="m-1 text-[#2998ff]">
            support@sharkroll.io
          </a>
          , and a Customer Support agent will ensure that your request is
          handled. When requesting that your account be closed, you should
          receive an email confirmation no more than 48 hours after sending us
          your request. If you haven't received written confirmation within this
          time limit, please contact our Support team via chat or phone to
          ensure your account is successfully closed.
        </p>

        <h3 className="text-[20px] font-bold">10. ANTI MONEY LAUNDERING</h3>
        <p className="text-justify text-[16px] md:pr-10">
          10.1 Sharkroll requires further evidence of identification and age
          from the player to verify his/her withdrawal application (i.e., clear
          valid picture identification and debit/credit card), that the player
          is, in fact, over 18 and complies with anti-money laundering
          requirements from his/her first deposit. Failure to provide
          appropriate documentation within time may lead to the freezing of the
          player’s account and withdrawal request. SHARKROLL may, from time to
          time, perform additional security checks to make sure all details
          provided by the player are correct.
          <br /> <br />
          10.2 By applying for an account at SHARKROLL, the player agrees to the
          below terms:
          <br />
          10.2.1 The player assures that he/she complies with all applicable
          anti-money laundering laws and regulations internationally.
          <br />
          10.2.2 The player is unaware and has no reason to suspect that the
          money used to fund his/her deposits in his/her account has been or
          will be derived from or connected to any money laundering or other
          illegal activities or prohibited activities by any international law.
          <br />
          10.2.3 The player agrees to provide SHARKROLL with data immediately,
          and it may request him to confirm all the above anti-money laundering
          precautions.
          <br /> <br />
          10.3 SHARKROLL alerts its users that it performs ongoing due diligence
          and risk assessments for each customer according to the risk level
          posed by the customer.
        </p>

        <h3 className="text-[20px] font-bold">11. REFUND</h3>
        <p className="text-justify text-[16px] md:pr-10">
          11.1 Once a deposit has been played in full, no refund will be
          considered. Only the remaining balance will be considered for refund.
          <br /> <br />
          11.2 A refund request will only be considered if it is made within the
          first twenty-four (24) hours of the transaction in question. You will
          need to provide a reason for the refund request, which we will
          consider on a case-by-case basis. The decision is final and not
          eligible for appeal.
          <br /> <br />
          11.3 In order to consider a refund, your account must be fully
          verified in accordance with our Anti-Money Laundering Policy. We
          reserve the right to request further documentation at any time to
          verify your identity.
        </p>
      </div>
    </div>
  );
}
